"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Memmory_1 = require("./Memmory");
const IO_1 = require("./IO");
class Core {
    index_labels() {
        for (let i = 0; i < this.polecenia.length; i++) {
            //console.log("pol: " + i + "\t" + this.polecenia[i].etykieta)
            if (this.polecenia[i].etykieta !== "") {
                //console.log("\t\t!!!\t" + i + ": " + this.polecenia[i].etykieta)
                this.etykiety[this.polecenia[i].etykieta] = i;
            }
        }
    }
    clear() {
        this.pamiec = new Memmory_1.Memmory;
        this.wejscie = new IO_1.Input([]);
        this.wyjscie = new IO_1.Output;
        this.etykiety = {};
        this.polecenia = [];
        this.interator_polecenia = 0;
        this.is_running = false;
    }
    encode(code) {
        this.clear();
        this.polecenia = code;
        this.index_labels();
    }
    dump() {
        return JSON.stringify(this);
    }
    execute_command() {
        this.polecenie = this.polecenia[this.interator_polecenia];
        this.executors[this.polecenie.komenda]();
    }
    execute(input) {
        this.wejscie = new IO_1.Input(input);
        this.is_running = true;
        while (this.is_running) {
            this.execute_command();
        }
        return this.wyjscie.get();
    }
    constructor() {
        this.pamiec = new Memmory_1.Memmory;
        this.wejscie = new IO_1.Input([]);
        this.wyjscie = new IO_1.Output;
        this.etykiety = {};
        this.polecenia = [];
        this.polecenie = {
            etykieta: "",
            komenda: "",
            typ_atrybutu: "",
            wartosc_atrybutu: ""
        };
        this.interator_wejscia = 0;
        this.interator_polecenia = 0;
        this.is_running = false;
        // this.executors = Executors;
        this.executors = {
            HALT: function () {
                this.is_running = false;
            },
            READ: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "READ: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "READ: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        throw "READ: ILLEGAL ARGUMENT 'number'";
                    case 'pointer':
                        this.pamiec.set(Number(this.polecenie.wartosc_atrybutu), this.wejscie.get());
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)), this.wejscie.get());
                        break;
                    default:
                        throw "READ: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            WRITE: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "READ: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "READ: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        this.wyjscie.put(Number(this.polecenie.wartosc_atrybutu));
                        break;
                    case 'pointer':
                        this.wyjscie.put(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)));
                        break;
                    case 'pointer_to_pointer':
                        this.wyjscie.put(this.pamiec.get(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu))));
                        break;
                    default:
                        throw "READ: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            LOAD: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "LOAD: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "LOAD: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        this.pamiec.set(0, Number(this.polecenie.wartosc_atrybutu));
                        break;
                    case 'pointer':
                        this.pamiec.set(0, this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)));
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(0, this.pamiec.get(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu))));
                        break;
                    default:
                        throw "LOAD: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            MULT: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "MULT: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "MULT: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        this.pamiec.set(0, this.pamiec.get(0) * Number(this.polecenie.wartosc_atrybutu));
                        break;
                    case 'pointer':
                        this.pamiec.set(0, this.pamiec.get(0) * this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)));
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(0, this.pamiec.get(0) * this.pamiec.get(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu))));
                        break;
                    default:
                        throw "MULT: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            ADD: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "ADD: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "ADD: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        this.pamiec.set(0, this.pamiec.get(0) + Number(this.polecenie.wartosc_atrybutu));
                        break;
                    case 'pointer':
                        this.pamiec.set(0, this.pamiec.get(0) + this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)));
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(0, this.pamiec.get(0) + this.pamiec.get(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu))));
                        break;
                    default:
                        throw "ADD: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            SUB: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "SUB: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "SUB: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        this.pamiec.set(0, this.pamiec.get(0) - Number(this.polecenie.wartosc_atrybutu));
                        break;
                    case 'pointer':
                        this.pamiec.set(0, this.pamiec.get(0) - this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)));
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(0, this.pamiec.get(0) - this.pamiec.get(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu))));
                        break;
                    default:
                        throw "SUB: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            DIV: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "DIV: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "DIV: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        this.pamiec.set(0, Math.floor(this.pamiec.get(0) / Number(this.polecenie.wartosc_atrybutu)));
                        break;
                    case 'pointer':
                        this.pamiec.set(0, Math.floor(this.pamiec.get(0) / this.pamiec.get(Number(this.polecenie.wartosc_atrybutu))));
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(0, Math.floor(this.pamiec.get(0) / this.pamiec.get(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)))));
                        break;
                    default:
                        throw "DIV: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            },
            JUMP: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "JUMP: MISSING ARGUMENT";
                if (this.polecenie.typ_atrybutu !== "label")
                    throw "JUMP: ILLEGAL ARGUMENT; NEED 'label'";
                this.interator_polecenia = this.etykiety[this.polecenie.wartosc_atrybutu];
            },
            JZERO: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "JZERO: MISSING ARGUMENT";
                if (this.polecenie.typ_atrybutu !== "label")
                    throw "JZERO: ILLEGAL ARGUMENT; NEED 'label'";
                if (this.pamiec.get(0) === 0)
                    this.interator_polecenia = this.etykiety[this.polecenie.wartosc_atrybutu];
                else
                    this.interator_polecenia++;
            },
            JGTZ: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "JGTZ: MISSING ARGUMENT";
                if (this.polecenie.typ_atrybutu !== "label")
                    throw "JGTZ: ILLEGAL ARGUMENT; NEED 'label'";
                if (this.pamiec.get(0) > 0)
                    this.interator_polecenia = this.etykiety[this.polecenie.wartosc_atrybutu];
                else
                    this.interator_polecenia++;
            },
            STORE: function () {
                if (this.polecenie.wartosc_atrybutu === "")
                    throw "DIV: MISSING ARGUMENT";
                switch (this.polecenie.typ_atrybutu) {
                    case 'label':
                        throw "STORE: ILLEGAL ARGUMENT 'label'";
                    case 'number':
                        throw "STORE: ILLEGAL ARGUMENT 'number'";
                    case 'pointer':
                        this.pamiec.set(Number(this.polecenie.wartosc_atrybutu), this.pamiec.get(0));
                        break;
                    case 'pointer_to_pointer':
                        this.pamiec.set(this.pamiec.get(Number(this.polecenie.wartosc_atrybutu)), this.pamiec.get(0));
                        break;
                    default:
                        throw "STORE: ILLEGAL ARGUMENT '" + this.polecenie.typ_atrybutu + "'";
                }
                this.interator_polecenia++;
            }
        };
        for (var element in this.executors) {
            this.executors[element] = this.executors[element].bind(this);
        }
    }
}
exports.Core = Core;
//# sourceMappingURL=Core.js.map


// WEBPACK FOOTER //
// ./utilities/RM/Core.js